import React, {FC, useMemo} from 'react';

import {useIndicatedTicketStatus} from '../../../../../../libs/inboxes/business/src/ticketing/ticketStatus';
import {makeGetTicketStatusesForCategory} from '../../../../../../libs/inboxes/store/src/ticketing/ticketStatusSelectors';
import {TicketStatusModel} from '../../../../../../libs/shared/core/src/models/api/ticketStatusModel';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {ConversationBaseModel} from '../../../../../models/api/conversationModel';
import {TicketStatusPill} from '../../../ticketing/ticketStatusPill';

/*
 * Props.
 */

interface CellTicketStatusPillProps {
  conversation: ConversationBaseModel;
  isCompact?: boolean;
}

/*
 * Component.
 */

export const CellTicketStatusPill: FC<CellTicketStatusPillProps> = ({isCompact, conversation}) => {
  const indicatedTicketStatus = useIndicatedTicketStatus({conversations: [conversation]});
  const getTicketStatusesForCategory = useMemo(
    () => makeGetTicketStatusesForCategory(getIndicatedTicketStatusCategory),
    [],
  );

  const ticketStatusesForCategory = useAppSelector((state) =>
    getTicketStatusesForCategory(state, {indicatedTicketStatus}),
  );

  // We only show the pill if there are multiple statuses for the category.
  if (!indicatedTicketStatus || ticketStatusesForCategory.length === 1) {
    return null;
  }

  return <TicketStatusPill isCompact={isCompact} ticketStatus={indicatedTicketStatus} />;
};

/*
 * Selectors.
 */

const getIndicatedTicketStatusCategory = (
  _: unknown,
  params: {indicatedTicketStatus: TicketStatusModel | undefined},
) => params.indicatedTicketStatus?.category;
